import { useState, useEffect } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Button, FormControl, FormHelperText, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import useScriptRef from 'hooks/useScriptRef';
import AnimateButton from 'ui-component/extended/AnimateButton';

// API
import { useApi } from 'Service/axios';

// components
import { FormBox } from './style';
import { toast } from 'react-toastify';

const CadastroLocalizacao = ({ getAllLocalizacoes, ...others }) => {
    const theme = useTheme();
    const scriptedRef = useScriptRef();
    const api = useApi();
    const [submitError, setSubmitError] = useState(null);
    const [almoxarifados, setAlmoxarifados] = useState([]);

    const getAlmoxarifados = async () => {
        const response = await api.getAllAlmoxarifado();
        setAlmoxarifados(response.data.almoxarifados);
    };

    function isAnyFieldEmpty(values) {
        const fieldsToCheck = ['descricao'];

        for (const field of fieldsToCheck) {
            if (values[field].trim() === '') {
                return true;
            }
        }

        return false;
    }

    const handleRegister = async (values) => {
        // monta um objeto apenas com valores !== de ""
        const filteredValues = Object.entries(values).reduce((acc, [key, value]) => {
            if (value !== '') {
                acc[key] = value;
            }
            return acc;
        }, {});

        // monta o payload final
        const localizacao = filteredValues;
        console.log(localizacao);
        try {
            const response = await api.createLocalizacao(localizacao);
            toast.success('Cadastrado com sucesso!');
            getAllLocalizacoes();
        } catch (error) {
            toast.error(error.response.data.erro);
            setSubmitError(error.response.data.erro);
        }
    };

    useEffect(() => {
        getAlmoxarifados();
    }, []);

    const clearValues = (values) => {
        values.descricao = '';
        values.id_almoxarifado = '';
    };

    return (
        <Formik
            initialValues={{
                descricao: '',
                id_almoxarifado: '',
                submit: null
            }}
            validationSchema={Yup.object().shape({
                descricao: Yup.string().required('Descrição é obrigatório'),
                id_almoxarifado: Yup.string().required('Almoxarifado é obrigatório')
            })}
            onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                try {
                    if (scriptedRef.current) {
                        setStatus({ success: true });
                        setSubmitting(false);
                    }
                    handleRegister(values);
                    clearValues(values);
                } catch (err) {
                    if (scriptedRef.current) {
                        setStatus({ success: false });
                        setErrors({ submit: err.msg });
                        setSubmitting(false);
                    }
                }
            }}
        >
            {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                <form noValidate onSubmit={handleSubmit} {...others} style={{ display: 'flex', flexDirection: 'column' }}>
                    <FormBox>
                        <FormControl
                            fullWidth
                            error={Boolean(touched.descricao && errors.descricao)}
                            sx={{ ...theme.typography.customInput }}
                        >
                            <InputLabel htmlFor="outlined-adornment-descricao-register">Descrição</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-descricao-register"
                                type="text"
                                value={values.descricao}
                                name="descricao"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                inputProps={{}}
                            />
                            {touched.descricao && errors.descricao && (
                                <FormHelperText error id="standard-weight-helper-text--register">
                                    {errors.descricao}
                                </FormHelperText>
                            )}
                        </FormControl>
                        <FormControl
                            fullWidth
                            error={Boolean(touched.id_almoxarifado && errors.id_almoxarifado)}
                            sx={{ ...theme.typography.customInput }}
                        >
                            <InputLabel htmlFor="outlined-adornment-id_almoxarifado-register">Almoxarifado</InputLabel>
                            <Select
                                style={{ height: '60px', padding: '20px 0px 0px 0px' }}
                                id="outlined-adornment-id_almoxarifado-register"
                                type="text"
                                value={values.id_almoxarifado}
                                name="id_almoxarifado"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                inputProps={{}}
                            >
                                {almoxarifados.length > 0 &&
                                    almoxarifados.map((almoxarifado) => (
                                        <MenuItem key={almoxarifado.id} value={almoxarifado.id}>
                                            {almoxarifado.descricao}
                                        </MenuItem>
                                    ))}
                            </Select>
                            {touched.id_almoxarifado && errors.id_almoxarifado && (
                                <FormHelperText error id="standard-weight-helper-text--register">
                                    {errors.id_almoxarifado}
                                </FormHelperText>
                            )}
                        </FormControl>
                    </FormBox>

                    {!submitError && errors.submit ? (
                        <Box sx={{ mt: 3 }}>
                            <FormHelperText error>{errors.submit}</FormHelperText>
                        </Box>
                    ) : (
                        <Box sx={{ mt: 3 }}>
                            <FormHelperText error>{submitError}</FormHelperText>
                        </Box>
                    )}

                    {/* BOTÕES */}
                    <Box sx={{ mt: 2 }}>
                        <AnimateButton>
                            <Button
                                sx={{ marginBottom: '3em' }}
                                disableElevation
                                disabled={isSubmitting || isAnyFieldEmpty(values)}
                                fullWidth
                                size="large"
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                {isSubmitting || isAnyFieldEmpty(values) ? 'Valores obrigatórios faltando' : 'Cadastrar Localização'}
                            </Button>
                        </AnimateButton>
                    </Box>
                </form>
            )}
        </Formik>
    );
};

export default CadastroLocalizacao;
